import ScratchCardProducts from "./ScratchCardProducts";
export default ScratchCardProducts;